import { useQuery } from 'react-query';

import { getV2ApiCompanyIdSpendLimitStatusByRequestRequestId } from 'src/client/spendesk-api';
import { type QueryState } from 'src/core/api/queryState';
import { mapQueryResultToQueryState } from 'src/core/api/utils/queryState';

import { useCompany } from '../../app/hooks/useCompany';
import { type SpendLimitStatus } from '../models/spendLimit';

export const useSpendLimitStatusByRequestQuery = ({
  requestId,
  enabled,
}: {
  requestId: string;
  enabled: boolean;
}): QueryState<SpendLimitStatus> => {
  const company = useCompany();
  const result = useQuery(
    ['spend-limits', 'status', 'by-request', requestId],
    async (): Promise<SpendLimitStatus> => {
      const { statusCode, body } =
        await getV2ApiCompanyIdSpendLimitStatusByRequestRequestId({
          path: { companyId: company.id, requestId },
        });
      if (statusCode !== 200) {
        throw new Error('Failed to fetch spend limit status');
      }

      const { spendLimitStatus, spendLimit } = body;
      return {
        spendLimitStatus: Object.values(spendLimitStatus),
        spendLimit,
      };
    },
    {
      enabled,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
  return mapQueryResultToQueryState(result);
};
